export function orderByRecommendedThenPremium<T>(
  plans: T[],
  getPremium: (p: T) => number | string | undefined | null
): T[] {
  const toNumber = (v: number | string | undefined | null): number => {
    if (typeof v === 'number') return Number.isFinite(v) ? v : Infinity
    const n = parseFloat(String(v ?? ''))
    return Number.isFinite(n) ? n : Infinity
  }

  const recommended = plans.filter((p: any) => !!p?.producerRecommended)
  const others = plans
    .filter((p: any) => !p?.producerRecommended)
    .sort((a, b) => toNumber(getPremium(a)) - toNumber(getPremium(b)))
  return [...recommended, ...others]
}

export const orderDentalPlans = (plans: any[]) =>
  orderByRecommendedThenPremium(plans, (p: any) => p?.rate?.monthlyPremium)

export const orderVisionPlans = (plans: any[]) =>
  orderByRecommendedThenPremium(plans, (p: any) => p?.planRate?.monthlyPremium)
